import type {
	ContentFeedUmbBlockPropertiesModel,
	GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
} from "#/_generated/umbraco/delivery-api/models";

export const getContentFeedContentByIdFilter = (
	properties?: ContentFeedUmbBlockPropertiesModel,
): GetUmbracoDeliveryApiV2ContentFeedContentIdParams => {
	const contentFilter = properties?.contentFilter;

	const root = properties?.source?.id;
	const tags = contentFilter?.tags;

	const contentTypeFilter = contentFilter?.contentType;

	return {
		root,
		tags,
		contentTypeFilter: contentTypeFilter ?? undefined,
		numberOfItems: properties?.noOfItems ?? 3,
		expand: "",
	};
};
